'use client';
import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import EcoLink from 'eco-design/base/eco-link';
import { useState } from 'react';
import './index.scss';
import EcoImg from 'eco-design/base/eco-img';
import IndexClient from './index.client';

export default function Content({ id, data = {} }: ContentServerProps) {
    const { title, list, bgColor = 'black' } = data;
    const prefixCls = 'index-user-story-1';

    const handleClickText = (i: number) => {
        const dom: HTMLParagraphElement | null = document.querySelector(`#editor-${id} .${prefixCls}-item-${i} .${prefixCls}-item-text`);
        if (dom) {
            dom.classList.contains('open') ? dom.classList.remove('open') : dom.classList.add('open');
        }
    };

    console.log('list', list);
    return (
        <GloLayout
            className={`editor-${prefixCls} editor-${prefixCls}-${id}`}
            id={id}
            data={data}
            floorName={`${prefixCls}`}
            style={{ backgroundColor: bgColor }}
        >
            <div className={`${prefixCls}-wrapper`}>
                <h2 className={`${prefixCls}-title`}>{title}</h2>
                <div className={`${prefixCls}-box`}>
                    <IndexClient list={list} prefixCls={prefixCls} id={id} />
                </div>
            </div>
        </GloLayout>
    );
}
